// extracted by mini-css-extract-plugin
module.exports = {"contentImageContainer":"styles_contentImageContainer__1MiDd","contentImage":"styles_contentImage__DmUQe"};